// extracted by mini-css-extract-plugin
export default {"container":"_65hHyxOJ495Nj6XlAl8HA7"};